__turbopack_context__.v({
  "root": "StoresSection-module__axgKuG__root",
});
